import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Table, TableModule } from "primeng/table";
import { TotalApMiscRequestDto } from "../../../../core/models/bcLedgers/totalApMiscRequestDto";
import { TotalApMiscData } from "../../../../core/models/bcLedgers/totalApMiscResponseDto";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { LoaderService } from "../../../../core/services/loader.service";
import { exportExcel } from "../../../../core/services/shared.service";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { FreightDetailsComponent } from "../freight-details/freight-details.component";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "jni-total-ap-misc",
  templateUrl: "./total-ap-misc.component.html",
  styleUrls: ["./total-ap-misc.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    ModalStackerComponent,
    FreightDetailsComponent,
    InputTextModule,
    ButtonModule,
  ],
})
export class TotalApMiscComponent implements OnInit, OnChanges {
  @Input() bcLedgerStacker!: BcLedgerStacker;
  totalApMiscParams!: TotalApMiscRequestDto;
  totalApMiscList: TotalApMiscData[] = [];
  total!: number;
  fileName = "Total Ap Misc";
  orderTrackingDisplayModal = false;
  trackingNumber = "";
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService,
    private _totalApMiscService: BcledgerService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.totalApMiscParams = { ...params } as TotalApMiscRequestDto;
    });
  }

  ngOnInit(): void {
    this.getTotalApMisc(this.totalApMiscParams);
  }

  getTotalApMisc(payload: TotalApMiscRequestDto) {
    this._loaderService.setLoaderState(true);
    this._totalApMiscService.getTotalApMisc(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.totalApMiscList = res.data.Data ?? [];
          this.total = res.data.Total;
          return;
        }
        this._toastrService.error(res.message ?? "No results found", "Error");
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("No results found", "Error");
      },
    });
  }

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    exportExcel(this.totalApMiscList, this.fileName);
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.totalApMiscParams = { ...this.bcLedgerStacker };
    }
  }

  onTrackingNumberSelection(trackingNumber: string) {
    if (trackingNumber) {
      this.trackingNumber = trackingNumber;
      this.orderTrackingDisplayModal = true;
    }
  }

  closeModalFromOrderTracking() {
    this.orderTrackingDisplayModal = false;
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
